import { InlineMessage, Loader } from "@saviynt/design-system";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useIntl } from "react-intl";
import { useSsoConfig } from "./hooks";
import SsoLandingPage from "./components/SsoLandingPage";
import SsoListPage from "./components/SsoListPage";

export default function SsoSettingsPage() {
  const navigate = useNavigate();
  const intl = useIntl();
  const { data: config, isLoading, isError, error } = useSsoConfig();
  const { success } = useSearch({
    strict: false,
  }) as { success?: string };

  const handleCreateSaml = () => {
    navigate({ to: "/admin/settings/sso-settings/create" });
  };

  const errorMessage =
    error instanceof Error
      ? error.message
      : intl.formatMessage({
          id: "ic9p1P",
          defaultMessage: "Failed to load SSO configuration. Please try again.",
          description: "Generic SSO load error message",
        });

  // Determine success message based on search param
  const successMessage = (() => {
    if (success === "created") {
      return intl.formatMessage({
        id: "Nlmckz",
        defaultMessage: "SSO configuration saved successfully",
        description:
          "Success message shown on list page after creating SSO configuration",
      });
    }
    if (success === "updated") {
      return intl.formatMessage({
        id: "GdIb0G",
        defaultMessage: "SSO configuration updated successfully",
        description:
          "Success message shown on list page after updating SSO configuration",
      });
    }
    return null;
  })();

  // When no SSO is configured, render the full-width landing page without wrapper padding
  if (!isLoading && !isError && config === null) {
    return <SsoLandingPage onCreateSaml={handleCreateSaml} />;
  }

  // When SSO is configured, render the full-width list page
  if (!isLoading && !isError && config != null) {
    return <SsoListPage config={config} successMessage={successMessage} />;
  }

  return (
    <div className="p-6">
      {isLoading && (
        <div className="flex items-center justify-center py-12">
          <Loader kind="loop" format="main" size="medium" color="brand" />
        </div>
      )}

      {isError && <InlineMessage colorTheme="critical" text={errorMessage} />}
    </div>
  );
}
